import React, { useState } from 'react';

const PengasuhanChecklist = () => {
  const [selectedMonth, setSelectedMonth] = useState(null);

  const checklistData = [
    {
      month: "Agustus 2025",
      monthNumber: "08",
      icon: "fas fa-rocket",
      color: "from-blue-500 to-blue-600",
      bgColor: "bg-blue-50",
      borderColor: "border-blue-500",
      tasks: [
        "Menghadiri rapat kick-off & memahami roadmap digitalisasi",
        "Menerima iPad dan mengikuti pelatihan penggunaan",
        "Menyusun data kamar & musyrif untuk input awal LMS/MDM",
        "Mempersiapkan komunikasi dengan wali saat FGD/sosialisasi"
      ],
      outputs: [
        "Musyrif siap menggunakan iPad",
        "Terdata awal untuk akun MDM & LMS",
        "Wali memahami fungsi iPad di pengasuhan"
      ],
      why: "Bulan ini adalah fondasi awal program digitalisasi. Tim pengasuhan harus memahami visi besar dan mempersiapkan diri sebagai ujung tombak implementasi di asrama. Tanpa pemahaman yang solid dari awal, akan sulit mengintegrasikan teknologi dengan nilai-nilai pengasuhan islami."
    },
    {
      month: "September 2025",
      monthNumber: "09",
      icon: "fas fa-warehouse",
      color: "from-green-500 to-green-600",
      bgColor: "bg-green-50",
      borderColor: "border-green-500",
      tasks: [
        "Menentukan lokasi penyimpanan aman iPad santri di asrama",
        "Mengecek kesiapan charger station/kabel kolektif",
        "Koordinasi dengan tim IT soal kebutuhan jaringan di asrama"
      ],
      outputs: [
        "Penyimpanan iPad santri aman & teratur",
        "Infrastruktur Wi-Fi memadai di kamar/asrama"
      ],
      why: "Infrastruktur fisik adalah kunci keberhasilan program. iPad yang tidak tersimpan dengan baik akan mudah rusak atau hilang. Jaringan yang lemah akan menghambat pembelajaran digital. Persiapan infrastruktur yang matang mencegah masalah teknis di kemudian hari."
    },
    {
      month: "Oktober 2025",
      monthNumber: "10",
      icon: "fas fa-database",
      color: "from-purple-500 to-purple-600",
      bgColor: "bg-purple-50",
      borderColor: "border-purple-500",
      tasks: [
        "Memberikan data kamar dan santri untuk diinput ke LMS/MDM",
        "Membantu verifikasi struktur akun musyrif di LMS (akses absensi, ibadah, pelanggaran, dsb)"
      ],
      outputs: [
        "LMS siap menampilkan aktivitas pengasuhan (sholat, kebersihan, dll) secara real-time"
      ],
      why: "Data yang akurat adalah jantung sistem digital. Struktur akun yang tepat memastikan setiap musyrif memiliki akses yang sesuai dengan tanggung jawabnya. Sistem yang terorganisir dengan baik akan memudahkan monitoring dan pelaporan aktivitas santri."
    },
    {
      month: "November 2025",
      monthNumber: "11",
      icon: "fas fa-clipboard-list",
      color: "from-orange-500 to-orange-600",
      bgColor: "bg-orange-50",
      borderColor: "border-orange-500",
      tasks: [
        "Ikut menyusun draft SOP penggunaan iPad oleh santri di asrama",
        "Menentukan aturan penggunaan iPad saat waktu ibadah, tidur, dsb"
      ],
      outputs: [
        "Tercipta aturan & SOP iPad di lingkungan boarding yang disiplin, terkontrol & aman"
      ],
      why: "SOP yang jelas mencegah penyalahgunaan teknologi dan memastikan iPad digunakan sesuai tujuan pendidikan. Aturan khusus untuk waktu ibadah dan istirahat menjaga keseimbangan antara teknologi dan spiritualitas, sesuai dengan nilai-nilai pesantren."
    },
    {
      month: "Desember 2025",
      monthNumber: "12",
      icon: "fas fa-hands-helping",
      color: "from-red-500 to-red-600",
      bgColor: "bg-red-50",
      borderColor: "border-red-500",
      tasks: [
        "Mendampingi santri pilot saat menerima iPad",
        "Menerapkan SOP pemakaian iPad di asrama secara terbatas",
        "Memberi masukan awal tentang kontrol MDM & LMS dari sisi pengasuhan"
      ],
      outputs: [
        "Pengasuhan aktif mendampingi implementasi tahap awal",
        "Ada catatan umpan balik ke manajemen"
      ],
      why: "Fase pilot adalah momen kritis untuk menguji sistem dalam kondisi nyata. Pendampingan intensif memastikan santri menggunakan iPad dengan benar. Feedback dari lapangan sangat berharga untuk penyempurnaan sistem sebelum implementasi penuh."
    },
    {
      month: "Januari 2026",
      monthNumber: "01",
      icon: "fas fa-chart-line",
      color: "from-indigo-500 to-indigo-600",
      bgColor: "bg-indigo-50",
      borderColor: "border-indigo-500",
      tasks: [
        "Input data absensi, ibadah, kebersihan, dll ke LMS",
        "Belajar mengintegrasikan pelaporan pelanggaran & apresiasi digital",
        "Uji keterpaduan nilai adab dalam sistem"
      ],
      outputs: [
        "Data pengasuhan mulai terdokumentasi digital",
        "Pengawasan musyrif berjalan sistematis"
      ],
      why: "Digitalisasi data pengasuhan memungkinkan monitoring yang lebih objektif dan sistematis. Integrasi pelaporan pelanggaran dan apresiasi dalam satu sistem memudahkan evaluasi perkembangan karakter santri secara komprehensif."
    },
    {
      month: "Februari 2026",
      monthNumber: "02",
      icon: "fas fa-chalkboard-teacher",
      color: "from-pink-500 to-pink-600",
      bgColor: "bg-pink-50",
      borderColor: "border-pink-500",
      tasks: [
        "Mengawal pelatihan siswa kelas pilot dalam penggunaan iPad",
        "Menyampaikan edukasi adab digital ke santri",
        "Membantu sosialisasi ke wali (via booklet/seminar)"
      ],
      outputs: [
        "Santri memahami etika penggunaan iPad di pondok",
        "Wali lebih percaya & mendukung program"
      ],
      why: "Edukasi adab digital sangat penting untuk memastikan teknologi tidak merusak akhlak santri. Sosialisasi ke wali santri membangun kepercayaan dan dukungan orang tua, yang krusial untuk keberhasilan program jangka panjang."
    },
    {
      month: "Maret 2026",
      monthNumber: "03",
      icon: "fas fa-comments",
      color: "from-teal-500 to-teal-600",
      bgColor: "bg-teal-50",
      borderColor: "border-teal-500",
      tasks: [
        "Ikut FGD evaluasi pilot (bersama guru, IT)",
        "Memberikan masukan sistem berdasarkan kendala lapangan di asrama"
      ],
      outputs: [
        "Sistem disempurnakan dari sisi pengasuhan (jadwal iPad, kendali akses, dll)"
      ],
      why: "Evaluasi menyeluruh dari berbagai perspektif memastikan sistem benar-benar siap untuk implementasi penuh. Masukan dari tim pengasuhan sangat berharga karena mereka yang paling memahami dinamika kehidupan asrama dan kebutuhan santri."
    },
    {
      month: "April 2026",
      monthNumber: "04",
      icon: "fas fa-expand-arrows-alt",
      color: "from-yellow-500 to-yellow-600",
      bgColor: "bg-yellow-50",
      borderColor: "border-yellow-500",
      tasks: [
        "Membantu distribusi iPad batch akhir ke seluruh santri",
        "Sosialisasi SOP penggunaan iPad ke santri baru",
        "Setup akses MDM/LMS ke semua kamar dan musyrif"
      ],
      outputs: [
        "Semua santri dan musyrif terhubung sistem",
        "SOP ditaati di lingkungan asrama"
      ],
      why: "Implementasi penuh memerlukan koordinasi yang sempurna. Semua santri harus mendapat perlakuan yang sama dan memahami aturan yang berlaku. Setup sistem yang menyeluruh memastikan tidak ada yang tertinggal dalam transformasi digital."
    },
    {
      month: "Mei 2026",
      monthNumber: "05",
      icon: "fas fa-eye",
      color: "from-emerald-500 to-emerald-600",
      bgColor: "bg-emerald-50",
      borderColor: "border-emerald-500",
      tasks: [
        "Monitoring simulasi digital penuh selama 1 pekan",
        "Menyampaikan laporan evaluasi simulasi dari sisi pengasuhan"
      ],
      outputs: [
        "Simulasi menunjukkan kesiapan pengasuhan terintegrasi sistem digital"
      ],
      why: "Simulasi penuh memberikan gambaran nyata tentang kesiapan sistem dalam kondisi operasional normal. Monitoring intensif selama satu pekan memungkinkan identifikasi masalah-masalah kecil yang mungkin terlewat sebelumnya."
    },
    {
      month: "Juni 2026",
      monthNumber: "06",
      icon: "fas fa-shield-alt",
      color: "from-cyan-500 to-cyan-600",
      bgColor: "bg-cyan-50",
      borderColor: "border-cyan-500",
      tasks: [
        "Mengikuti training ulang (refreshment) penggunaan LMS/MDM",
        "Uji keamanan data absensi & adab",
        "Memastikan semua musyrif paham peran digital mereka"
      ],
      outputs: [
        "Musyrif percaya diri menggunakan sistem",
        "Sistem keamanan data terjaga"
      ],
      why: "Refreshment training memastikan semua musyrif tetap update dengan perkembangan sistem. Keamanan data santri adalah prioritas utama yang harus dijaga dengan ketat. Musyrif yang percaya diri akan lebih efektif dalam menggunakan teknologi."
    },
    {
      month: "Juli 2026",
      monthNumber: "07",
      icon: "fas fa-flag-checkered",
      color: "from-violet-500 to-violet-600",
      bgColor: "bg-violet-50",
      borderColor: "border-violet-500",
      tasks: [
        "Finalisasi SOP pengasuhan berbasis iPad & LMS",
        "Berperan aktif dalam launching sistem digital ke wali",
        "Mempersiapkan rotasi jadwal iPad (jam pakai, pengawasan)"
      ],
      outputs: [
        "Sistem resmi dimulai, wali santri percaya, pengasuhan siap mendampingi era digital"
      ],
      why: "Finalisasi SOP menandai kematangan sistem dan kesiapan untuk operasional penuh. Launching yang sukses membangun kepercayaan stakeholder. Rotasi jadwal yang teratur memastikan semua santri mendapat akses yang adil ke teknologi."
    }
  ];

  const finalOutputs = [
    {
      title: "Input Data Pengasuhan Digital",
      description: "Musyrif aktif menginput data pengasuhan (sholat, kebersihan, absensi, pelanggaran) ke sistem LMS.",
      icon: "fas fa-database",
      color: "text-blue-600",
      bgColor: "bg-blue-50"
    },
    {
      title: "Sistem Perizinan 3 Arah",
      description: "Perizinan santri (keluar, kunjungan, sakit) dilakukan digital secara 3 arah: wali – pengasuh – manajemen.",
      icon: "fas fa-exchange-alt",
      color: "text-green-600",
      bgColor: "bg-green-50"
    },
    {
      title: "Monitoring Real-time untuk Wali",
      description: "Seluruh laporan harian santri dapat dipantau wali secara real-time melalui LMS.",
      icon: "fas fa-eye",
      color: "text-purple-600",
      bgColor: "bg-purple-50"
    },
    {
      title: "Pengawasan iPad Aktif",
      description: "Pengasuh berperan aktif dalam pengawasan iPad di asrama: waktu pakai, tempat simpan, pengendalian aplikasi.",
      icon: "fas fa-shield-alt",
      color: "text-orange-600",
      bgColor: "bg-orange-50"
    }
  ];

  const keyPrinciples = [
    {
      title: "Integrasi Teknologi & Spiritualitas",
      description: "Memastikan teknologi mendukung, bukan mengganggu, aktivitas ibadah dan pembinaan akhlak",
      icon: "fas fa-balance-scale"
    },
    {
      title: "Transparansi untuk Wali Santri",
      description: "Memberikan akses real-time kepada orang tua untuk memantau perkembangan anak",
      icon: "fas fa-eye"
    },
    {
      title: "Kedisiplinan Digital",
      description: "Menjaga agar penggunaan iPad tetap terkontrol dan sesuai dengan tujuan pendidikan",
      icon: "fas fa-gavel"
    },
    {
      title: "Pembinaan Karakter Sistematis",
      description: "Menggunakan data digital untuk pembinaan karakter yang lebih objektif dan terukur",
      icon: "fas fa-chart-line"
    }
  ];

  return (
    <div className="min-h-screen py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-green-500 to-blue-600 rounded-full mb-6">
            <i className="fas fa-home text-white text-3xl"></i>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Checklist Tugas Tim Pengasuhan
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Roadmap lengkap tugas dan tanggung jawab Tim Pengasuhan dalam transformasi digital Al Wafi dari Agustus 2025 hingga Juli 2026
          </p>
        </div>

        {/* Key Principles */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Prinsip Utama Pengasuhan Digital</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {keyPrinciples.map((principle, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-6 text-center hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${principle.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-800 mb-2">{principle.title}</h3>
                <p className="text-gray-600 text-sm">{principle.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Monthly Checklist */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Checklist Bulanan Tim Pengasuhan</h2>
          <div className="space-y-6">
            {checklistData.map((monthData, index) => (
              <div key={index} className={`${monthData.bgColor} rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden`}>
                <div className={`h-2 bg-gradient-to-r ${monthData.color}`}></div>
                <div className="p-6">
                  <div 
                    className="flex items-center justify-between cursor-pointer"
                    onClick={() => setSelectedMonth(selectedMonth === index ? null : index)}
                  >
                    <div className="flex items-center space-x-4">
                      <div className={`w-16 h-16 bg-gradient-to-r ${monthData.color} rounded-full flex items-center justify-center`}>
                        <span className="text-white font-bold text-lg">{monthData.monthNumber}</span>
                      </div>
                      <div>
                        <h3 className="text-2xl font-bold text-gray-800">{monthData.month}</h3>
                        <p className="text-gray-600">{monthData.tasks.length} Tugas Utama</p>
                      </div>
                    </div>
                    <i className={`fas ${selectedMonth === index ? 'fa-chevron-up' : 'fa-chevron-down'} text-gray-400 text-xl`}></i>
                  </div>

                  {selectedMonth === index && (
                    <div className="mt-6 space-y-6">
                      {/* Why Section */}
                      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                        <div className="flex items-start space-x-3">
                          <i className="fas fa-lightbulb text-yellow-500 text-lg mt-1"></i>
                          <div>
                            <h4 className="font-bold text-yellow-800 mb-2">💡 Mengapa Bulan Ini Penting?</h4>
                            <p className="text-yellow-700 leading-relaxed">{monthData.why}</p>
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        {/* Tasks */}
                        <div className="bg-white rounded-lg p-6 shadow-sm">
                          <h4 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                            <i className="fas fa-tasks text-blue-500 mr-2"></i>
                            Tugas Utama
                          </h4>
                          <div className="space-y-3">
                            {monthData.tasks.map((task, taskIndex) => (
                              <div key={taskIndex} className="flex items-start space-x-3">
                                <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                                  <span className="text-blue-600 font-bold text-sm">{taskIndex + 1}</span>
                                </div>
                                <span className="text-gray-700">{task}</span>
                              </div>
                            ))}
                          </div>
                        </div>

                        {/* Outputs */}
                        <div className="bg-white rounded-lg p-6 shadow-sm">
                          <h4 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                            <i className="fas fa-bullseye text-green-500 mr-2"></i>
                            Target Output
                          </h4>
                          <div className="space-y-3">
                            {monthData.outputs.map((output, outputIndex) => (
                              <div key={outputIndex} className="flex items-start space-x-3">
                                <i className="fas fa-check-circle text-green-500 mt-1 flex-shrink-0"></i>
                                <span className="text-gray-700">{output}</span>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Final Outputs */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Output Akhir Tim Pengasuhan (Juli 2026)</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {finalOutputs.map((output, index) => (
              <div key={index} className={`${output.bgColor} rounded-xl p-6 border-l-4 border-current ${output.color} hover:shadow-lg transition-all duration-300`}>
                <div className="flex items-start space-x-4">
                  <div className={`w-12 h-12 ${output.bgColor} rounded-lg flex items-center justify-center border-2 border-current ${output.color}`}>
                    <i className={`${output.icon} ${output.color} text-lg`}></i>
                  </div>
                  <div>
                    <h3 className={`text-lg font-bold ${output.color} mb-2`}>{output.title}</h3>
                    <p className="text-gray-700">{output.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Progress Overview */}
        <section className="mb-16">
          <div className="bg-gradient-to-r from-green-600 to-blue-600 rounded-2xl p-8 text-white">
            <h2 className="text-3xl font-bold text-center mb-8">Ringkasan Program Pengasuhan</h2>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="text-4xl font-bold mb-2">12</div>
                <div className="text-green-100">Bulan Program</div>
                <div className="text-sm text-green-200">Agustus 2025 - Juli 2026</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold mb-2">{checklistData.reduce((total, month) => total + month.tasks.length, 0)}</div>
                <div className="text-green-100">Total Tugas</div>
                <div className="text-sm text-green-200">Tugas Utama</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold mb-2">4</div>
                <div className="text-green-100">Output Utama</div>
                <div className="text-sm text-green-200">Hasil Akhir</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold mb-2">100%</div>
                <div className="text-green-100">Digital</div>
                <div className="text-sm text-green-200">Terintegrasi</div>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="text-center">
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-green-500 to-blue-600 rounded-full mb-6">
              <i className="fas fa-home text-white text-2xl"></i>
            </div>
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Tim Pengasuhan Siap Berdigitalisasi?</h2>
            <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
              Ikuti roadmap lengkap ini untuk memastikan transformasi digital pengasuhan berjalan sukses dan sesuai dengan nilai-nilai islami
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-gradient-to-r from-green-500 to-blue-600 text-white px-8 py-4 rounded-full font-semibold text-lg hover:from-green-600 hover:to-blue-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1">
                <i className="fas fa-download mr-2"></i>
                Download Checklist
              </button>
              <button className="border-2 border-green-500 text-green-600 px-8 py-4 rounded-full font-semibold text-lg hover:bg-green-500 hover:text-white transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1">
                <i className="fas fa-phone mr-2"></i>
                Konsultasi Tim
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PengasuhanChecklist;
